import React from 'react';
import {ISelectProps, SelectInput} from '~/components/Controls/Select';
import {FormField, hasError, IFieldProps, onChangeField} from '~/components/Form';
import {adTypes} from '~/lib/adTypes';
import {Intent} from '~/lib/intent';
import {ID} from '~/lib/model';

type ISelectAdTypeProps = Omit<ISelectProps<ID>, 'items'>;

export const SelectAdType = ({
    disabled,
    ...props
}: ISelectAdTypeProps) => <SelectInput {...props} disabled={disabled}
    items={adTypes.map(adType => ({
        label: adType.name,
        value: adType.value
    }))}/>;

export const SelectAdTypeField = (props: IFieldProps<ISelectAdTypeProps>) => <FormField {...props}>
    <SelectAdType {...props.options}
        intent={hasError(props) && Intent.DANGER}
        value={props.field.value} onChange={value => onChangeField(props, value)}
    />
</FormField>;
